import RequestAbstract from "../abstract";

export default class RolePermissions extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/cabinet/role-permissions";
    }

}
